import BorderWrapper from "src/components/atoms/BorderWrapper";
import AgentCard from "src/components/molecules/AgentCard";

const TopAgent = ({ agents }) => {
  return (
    <>
      <BorderWrapper>
        <div className="text-light-gray font-bold mb-5">Top 5 Agents</div>
        <div className="border-white rounded-lg overflow-hidden ">
          <div className="grid grid-rows-5 gap-3">
            {agents.map((data, index) => (
              <div key={`${data.title}-${index}`} className="col-span-1">
                <AgentCard {...data} />
              </div>
            ))}
          </div>
        </div>
      </BorderWrapper>
    </>
  );
};

export default TopAgent;
